import { Component, OnInit } from '@angular/core';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-holiday-list',
  templateUrl: './holiday-list.component.html',
  styleUrls: ['./holiday-list.component.css']
})
export class HolidayListComponent implements OnInit {

  Submitted:boolean=false;
  HolidayList:any;
  HolidayTypeList:any;

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  HolidayModel = {
    HolidayListID: 0,
    HolidaysName: '',
    HolidayTypeID: 0,
    Description: '',
    StartDate: moment(new Date()).format('DD-MMM-YYYY'),
    EndDate: moment(new Date()).format('DD-MMM-YYYY'),
    IsActive: true
};

Clear() {
    this.HolidayModel.HolidayListID = 0;
    this.HolidayModel.HolidayTypeID = 0;
    this.HolidayModel.HolidaysName = '';
    this.HolidayModel.Description = '';
    this.HolidayModel.StartDate =moment(new Date()).format('DD-MMM-YYYY');
    this.HolidayModel.EndDate = moment(new Date()).format('DD-MMM-YYYY');
    this.Submitted = false;
    this.HolidayModel.IsActive = true
};

Vaildate() {
    return this.HolidayModel.HolidayTypeID == 0;
}


SaveHoliday(valid) {
    this.Submitted = true;
    if (valid && !this.Vaildate()) {
      this.spinnerService.show();
      this.HolidayModel.StartDate = this.HolidayModel.StartDate != null && this.HolidayModel.StartDate != '' ? moment(this.HolidayModel.StartDate).format('DD-MMM-YYYY') : '';
      this.HolidayModel.EndDate = this.HolidayModel.EndDate != null && this.HolidayModel.EndDate != '' ? moment(this.HolidayModel.EndDate).format('DD-MMM-YYYY') : '';
        this.adminservice.SaveHoliday(JSON.stringify(this.HolidayModel)).subscribe((data: any) => {
          this.spinnerService.hide();
            if (data.webResponse.Status && this.HolidayModel.HolidayListID == 0) {
                this.Clear();
            }
            this.GetAllHoliday();
            this.globalHelper.CheckActionStatus(data);
        });
    }
}

GetAllHoliday() {
  this.spinnerService.show();
    this.adminservice.GetAllHoliday().subscribe((data: any) => {
        this.HolidayList = data.HolidayList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
    });
};


Edit(obj) {
    this.HolidayModel.HolidayListID = obj.HolidayListID;
    this.HolidayModel.HolidaysName = obj.HolidaysName;
    this.HolidayModel.Description = obj.Description;
    this.HolidayModel.HolidayTypeID = obj.HolidayTypeID;
    this.HolidayModel.StartDate = moment(obj.StartDate).format('DD-MMM-YYYY');
    this.HolidayModel.EndDate = moment(obj.EndDate).format('DD-MMM-YYYY');
    this.HolidayModel.IsActive = obj.IsActive;

};

HolidayMarkActive(item) {
    this.HolidayModel.HolidayListID = item.HolidayListID;
    this.HolidayModel.IsActive = item.IsActive == true ? false : true;
    this.adminservice.HolidayMarkActive(JSON.stringify(this.HolidayModel)).subscribe((data: any) => {
        this.GetAllHoliday();
        this.globalHelper.CheckActionStatus(data);

    });
}
  ngOnInit() {
    this.GetAllHolidayType();
    this.GetAllHoliday();
  }

  GetAllHolidayType() {
    this.lookupservice.GetLookupsList('HolidayType', '').subscribe((data: any) => {
        this.HolidayTypeList = data.LookupItems;
    });
};


}
